import { createAction } from '@reduxjs/toolkit';

export { changeLocale, languageDataFetched } from './reducer';

export const fetchLanguageData = createAction('fetchLanguageData', (locale?: string) => ({
    payload: locale,
}));
